import { Menu } from "@/components/Icon"
import React, { useState } from "react"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import { useTranslation } from "react-i18next"
import Button from "@/components/Button"
import { AnimatePresence, m } from "framer-motion"
import { PopOutMenu } from "./PopOutMenu"
import { JobMapByTeam, JobMapByLocation } from "../utils/useLever"
import { FilterResult } from "./FilterResult"

type PopOutMenuProps = {
  teamsFilter: string[]
  setTeamsFilter: (teams: string[]) => void
  locFilter: string[]
  setLocFilter: (loc: string[]) => void
  jobMapByTeam: JobMapByTeam
  jobMapByLocation: JobMapByLocation
  resultsCount: number
}

export const Filter = ({
  jobMapByTeam,
  jobMapByLocation,
  teamsFilter,
  setTeamsFilter,
  locFilter,
  setLocFilter,
  resultsCount,
}: PopOutMenuProps) => {
  const { t } = useTranslation("careers")
  const [isFilterOpen, setFilterOpen] = useState(false)
  const teamsExcludeAll = teamsFilter.filter(x => x !== "All Teams")
  const locExcludeAll = locFilter.filter(x => x !== "All Location")
  const filterCount = teamsExcludeAll.length + locExcludeAll.length
  return (
    <React.Fragment>
      <Flex
        pb={1}
        customCss={
          filterCount || !resultsCount
            ? { borderBottom: "1px solid #9EA1A2" }
            : { borderBottom: "none" }
        }
      >
        <Typography variant={"careerPrimaryCTA"} leadingTrim color="#001B3C">
          {resultsCount <= 1
            ? `${resultsCount} ${t("filter.result")}`
            : `${resultsCount} ${t("filter.result_plural")}`}
        </Typography>
        <Button
          display="flex"
          ml="auto"
          variant="plain"
          onClick={() => setFilterOpen(!isFilterOpen)}
        >
          <Typography
            variant={"careerPrimaryCTA"}
            leadingTrim
            color="primaryBrightBlueLightBg"
          >
            {filterCount === 0
              ? `${t("filter.title")}`
              : filterCount === 1
              ? `${filterCount} ${t("filter.title")}`
              : `${filterCount} ${t("filter.title_plural")}`}
          </Typography>
          <Menu ml={"10px"} fontSize={22} color="primaryBrightBlueLightBg" />
        </Button>
      </Flex>
      {filterCount > 0 && (
        <FilterResult
          teamsFilter={teamsExcludeAll}
          setTeamsFilter={setTeamsFilter}
          locFilter={locExcludeAll}
          setLocFilter={setLocFilter}
        ></FilterResult>
      )}
      <AnimatePresence>
        {isFilterOpen && (
          <m.div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 99,
            }}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ bounce: 0, duration: 0.2 }}
          >
            <PopOutMenu
              onCloseButtonClick={() => {
                setFilterOpen(false)
              }}
              jobMapByTeam={jobMapByTeam}
              jobMapByLocation={jobMapByLocation}
              teamsFilter={teamsFilter}
              setTeamsFilter={setTeamsFilter}
              locFilter={locFilter}
              setLocFilter={setLocFilter}
            ></PopOutMenu>
          </m.div>
        )}
      </AnimatePresence>
    </React.Fragment>
  )
}
